import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const OrgPermissionsForm = (props) => {
  const [orgId, setOrgId] = useState("");
  const [orgData, setOrgData] = useState([]);
  const [moduleServicesData, setModuleServicesData] = useState();

  const { sendRequest: getOrg } = useHttp();

  const orgDetails = () => {
    getOrg(
      {
        url: `/api/organisation/`,
      },
      (res) => {
        if (res) {
          setOrgData(res);
        }
      }
    );
  };

  useEffect(() => {
    orgDetails();
  }, [getOrg]);

  const handleOrgChange = (e) => {
    const id = e.target.value;
    // console.log(id);

    setOrgId(id);
  };

  useEffect(() => {
    if (orgId) {
      serviceAllData(orgId);
    } else {
      setModuleServicesData("")
    }
  }, [orgId]);

  const { sendRequest: getServiceAllData } = useHttp();

  const serviceAllData = (orgId) => {
    getServiceAllData(
      {
        url: `/api/serviceRoleAllocationByOrg/?orgId=${orgId}&createdBy=${localStorage.getItem(
          "id"
        )}`,
      },
      (data) => {
        // console.log("serviceRoleAllocation data", data);
        setModuleServicesData(data);
      }
    );
  };

  useEffect(() => {
    serviceAllData();
  }, [getServiceAllData]);

  const handleCheckboxChange = (
    moduleIndex,
    subServiceIndex,
    serviceIndex,
    isSubServiceCheckbox
  ) => {
    setModuleServicesData((prevData) => {
      return prevData.map((module, mIdx) => {
        if (mIdx !== moduleIndex) return module;

        return {
          ...module,
          subService: module.subService.map((subService, ssIdx) => {
            if (ssIdx !== subServiceIndex) return subService;

            if (isSubServiceCheckbox) {
              // Check or uncheck all associated services
              const newStatus = !subService.services.every(
                (service) => service.status
              );
              return {
                ...subService,
                services: subService.services.map((service) => ({
                  ...service,
                  status: newStatus,
                })),
              };
            } else {
              // Update the status of a specific service
              return {
                ...subService,
                services: subService.services.map((service, sIdx) => {
                  if (sIdx !== serviceIndex) return service;
                  return {
                    ...service,
                    status: !service.status,
                  };
                }),
              };
            }
          }),
        };
      });
    });
  };

  const { sendRequest: postOrgPermissions } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);
    console.log(moduleServicesData);

    postOrgPermissions(
      {
        url: "/api/organizationServiceAllocation/",
        method: "POST",
        body: moduleServicesData,
      },
      (data) => {
        props.addForm(false);
        // console.log(data);

        toast.success("Organization Permissions Updated");
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    Organization Services Permissions Form{" "}
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                  <div className="col-md-1"></div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Organization Name</label>
                        <select
                          className="form-control"
                          value={orgId}
                          onChange={(e) => handleOrgChange(e)}
                          required
                        >
                          <option value="">Select</option>
                          {orgData &&
                            orgData.map((x) => (
                              <option key={x.orgId} value={x.orgId}>
                                {x.orgName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-8">
                      {moduleServicesData &&
                        moduleServicesData.map((itm, moduleIndex) => {
                          return (
                            <div>
                              <div className="row">
                                <h6 className="text-success" key={moduleIndex}>
                                  {itm.moduleName}
                                </h6>

                                {itm.subService &&
                                  itm.subService.map(
                                    (subitm, subServiceIndex) => {
                                      const allChecked = subitm.services.every(
                                        (service) => service.status
                                      );
                                      return (
                                        <div
                                          style={{ width: "800px" }}
                                          key={subServiceIndex}
                                        >
                                          <div className="row">
                                            <table
                                              className="table table-bordered text-center"
                                              style={{ marginTop: "2px" }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      checked={allChecked}
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          moduleIndex,
                                                          subServiceIndex,
                                                          null,
                                                          true
                                                        )
                                                      }
                                                    />
                                                    {subitm.serviceSubName}
                                                  </th>
                                                  <th colSpan={2}></th>
                                                </tr>
                                                <tr>
                                                  <th>Service Name</th>
                                                  <th>Service Access</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {subitm.services &&
                                                  subitm.services.map(
                                                    (
                                                      serviceitm,
                                                      serviceIndex
                                                    ) => (
                                                      <tr key={serviceIndex}>
                                                        <td>
                                                          {
                                                            serviceitm.serviceName
                                                          }
                                                        </td>
                                                        <td>
                                                          <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={
                                                              serviceitm.status
                                                            }
                                                            onChange={() =>
                                                              handleCheckboxChange(
                                                                moduleIndex,
                                                                subServiceIndex,
                                                                serviceIndex,
                                                                false
                                                              )
                                                            }
                                                          />
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  <hr />

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrgPermissionsForm;
